import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// withCredentials sends/receives the httpOnly admin auth cookie.
const api = axios.create({ baseURL: API, withCredentials: true });

// ---- Public ----
export const fetchProducts = (params = {}) =>
  api.get("/products", { params }).then((r) => r.data);

export const fetchProduct = (id) =>
  api.get(`/products/${id}`).then((r) => r.data);

export const fetchCategories = () =>
  api.get("/categories").then((r) => r.data);

export const fetchSettings = () =>
  api.get("/settings").then((r) => r.data);

export const adminUpdateSettings = (payload) =>
  api.put("/admin/settings", payload).then((r) => r.data);

export const createOrder = (payload) =>
  api.post("/orders", payload).then((r) => r.data);

// ---- Payments (Stripe) ----
export const createCheckoutSession = (payload) =>
  api.post("/payments/checkout", payload).then((r) => r.data);

export const getPaymentStatus = (sessionId) =>
  api.get(`/payments/status/${sessionId}`).then((r) => r.data);

// ---- Admin auth ----
export const adminLogin = (email, password) =>
  api.post("/admin/login", { email, password }).then((r) => r.data);

export const adminLogout = () =>
  api.post("/admin/logout").then((r) => r.data);

export const adminMe = () => api.get("/admin/me").then((r) => r.data);

// ---- Customer auth (Emergent Google) ----
export const authSession = (sessionId) =>
  api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } }).then((r) => r.data);

export const authMe = () => api.get("/auth/me").then((r) => r.data);

export const authLogout = () => api.post("/auth/logout").then((r) => r.data);

// ---- Admin products ----
export const adminCreateProduct = (payload) =>
  api.post("/admin/products", payload).then((r) => r.data);

export const adminUpdateProduct = (id, payload) =>
  api.put(`/admin/products/${id}`, payload).then((r) => r.data);

export const adminDeleteProduct = (id) =>
  api.delete(`/admin/products/${id}`).then((r) => r.data);

// ---- Admin orders + stats ----
export const adminFetchOrders = () =>
  api.get("/admin/orders").then((r) => r.data);

export const adminUpdateOrderStatus = (id, status) =>
  api.put(`/admin/orders/${id}`, { status }).then((r) => r.data);

export const adminFetchStats = () =>
  api.get("/admin/stats").then((r) => r.data);

export default api;
